import { ThemeBus } from './events-bus.js';
import { EVENTS } from './event-constants.js';

const LINKED_LINE_PROPERTY = '_linked_line';
const FOR_VARIANT_PROPERTY = '_for_variant';
const INSTALLATION_FOR_PROPERTY = '_installation_for';
const FOR_PROPERTY = 'For';

class InstallationBanner extends HTMLElement {
  connectedCallback() {
    this.#button = this.querySelector('[data-installation-add]');
    this.#button?.addEventListener('click', this.#onAdd);
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#onAdd);
  }

  #button = null;

  #onAdd = async (event) => {
    event.preventDefault();

    const variantId = Number(this.dataset.productId);
    const lineKey = this.dataset.itemKey;
    const parentProductId = this.dataset.parentProductId;
    if (!variantId || !lineKey || !parentProductId || this.#button?.disabled) return;

    this.#setLoading(true);
    ThemeBus.dispatchEvent(new Event(EVENTS.cartUpdating));
    let cartUpdated = false;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                [LINKED_LINE_PROPERTY]: lineKey,
                [FOR_VARIANT_PROPERTY]: this.dataset.productVariantId || '',
                [INSTALLATION_FOR_PROPERTY]: parentProductId,
                [FOR_PROPERTY]: this.dataset.productTitle || '',
              },
            },
          ],
        }),
      });

      const result = await response.json();

      if (result.status) {
        console.error('[InstallationBanner]', result.description || result.message);
        return;
      }

      ThemeBus.dispatchEvent(new Event(EVENTS.cartUpdated));
      cartUpdated = true;
    } catch (error) {
      console.error('[InstallationBanner] Failed to add installation', error);
    } finally {
      this.#setLoading(false);
      if (!cartUpdated) {
        ThemeBus.dispatchEvent(new Event(EVENTS.cartUpdateEnd));
      }
    }
  };

  #setLoading(loading) {
    this.toggleAttribute('aria-busy', loading);
    if (this.#button) {
      this.#button.disabled = loading;
    }
  }
}

customElements.define('installation-banner', InstallationBanner);
